var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar app-navbar navbar-toggleable-md d-flex justify-content-center"},[_c('div',{staticClass:"navbar-brand-container d-flex align-items-center justify-content-start"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('i',{staticClass:"i-vuestic"})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24c4e3e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/navbar/Navbar.vue
// module id = 1AXY
// module chunks = 1